
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import Layout from '../components/feature/Layout';

const Home = lazy(() => import('../pages/home/page'));
const About = lazy(() => import('../pages/about/page'));
const Programs = lazy(() => import('../pages/programs/page'));
const Gallery = lazy(() => import('../pages/gallery/page'));
const Foundation = lazy(() => import('../pages/foundation/page'));
const Testimonies = lazy(() => import('../pages/testimonies/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const PrayerRequest = lazy(() => import('../pages/prayer-request/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      { path: '/', element: <Home /> },
      { path: '/about', element: <About /> },
      { path: '/programs', element: <Programs /> },
      { path: '/testimonies', element: <Testimonies /> },
      { path: '/gallery', element: <Gallery /> },
      { path: '/foundation', element: <Foundation /> },
      { path: '/contact', element: <Contact /> },
      { path: '/prayer-request', element: <PrayerRequest /> },
      { path: '*', element: <NotFound /> },
    ],
  },
];

export default routes;
